import { GenericFailure, CommonSuccess } from '@playq/services-shared';

import { IInvokeScriptsHook } from '/common/scripts/types';
import { UseMutationOptionsExtended } from '/api/service-hooks';

import { useEitherMutationScripted } from '../scriptsService/useEitherMutationScripted';

import { IAppsPackageUpdateOptionsVariables, IUpdatePackageParams } from './types';
import { appsPackagesService, appsPackagesServiceName, updatePackageMutationKey } from './constants';

export const useAppsPackageUpdateScripted = (
  scriptsResolver: IInvokeScriptsHook,
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, IAppsPackageUpdateOptionsVariables>
) =>
  useEitherMutationScripted<IUpdatePackageParams, CommonSuccess, IInvokeScriptsHook>({
    serviceMethod: appsPackagesService.update.bind(appsPackagesService),
    scriptsResolver,
    snackbarMessageMetadata: {
      serviceName: appsPackagesServiceName,
      mutationType: 'package update',
    },
    options: {
      mutationKey: updatePackageMutationKey,
      ...options,
    },
  });
